import {NestedTreeControl} from '@angular/cdk/tree';
import {ChangeDetectionStrategy, Component, inject, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {MatNestedTreeNode, MatTree, MatTreeNestedDataSource, MatTreeNodeDef, MatTreeNodeOutlet} from '@angular/material/tree';
import {Router, RouterLink} from '@angular/router';
import {NbButtonModule, NbIconModule, NbMenuItem, NbTooltipModule} from '@nebular/theme';
import {NgClass} from '@angular/common';

interface MenuItemWithLevel extends NbMenuItem {
  level?: number;
  children?: MenuItemWithLevel[];
}

@Component({
  selector: 'app-compact-menu',
  templateUrl: './modal-menu.component.html',
  styleUrls: ['./modal-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatTree,
    MatNestedTreeNode,
    NgClass,
    NbIconModule,
    NbTooltipModule,
    MatTreeNodeOutlet,
    NbButtonModule,
    RouterLink,
    MatTreeNodeDef
  ]
})
export class ModalMenuComponent implements OnInit {

  @Input() items: MenuItemWithLevel[];

  treeControl = new NestedTreeControl<MenuItemWithLevel>(node => node.children);
  dataSource = new MatTreeNestedDataSource<MenuItemWithLevel>();
  hideAll = false;
  router = inject(Router);

  hasChild = (_: number, node: MenuItemWithLevel) => !!node.children && node.children.length > 0;
  rootLevel = (_: number, node: MenuItemWithLevel) => !node.level;

  ngOnInit(): void {
    this.dataSource.data = this.setLevel(this.items, 0);
  }

  setLevel(data: MenuItemWithLevel[], level: number): MenuItemWithLevel[] {
    data.forEach((item: MenuItemWithLevel) => {
      item.level = level;
      if (item.children?.length > 0) {
        this.setLevel(item.children, level + 1);
      }
    });
    return data;
  }

  isActive(item: MenuItemWithLevel): boolean {
    if (item.link === this.router.url) {
      return true;
    }

    if (this.router.url.indexOf(item.link) >= 0) {
      return true;
    }

    if (item.children !== undefined && item.children.length) {
      return item.children.some(menuItem => this.router.url.indexOf(menuItem.link) >= 0);
    }

    return false;
  }

}
